var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavorites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 24.25C16 24.25 6.625 19 6.625 12.625C6.625 11.498 7.01546 10.4059 7.72996 9.53431C8.44445 8.66277 9.43884 8.0657 10.5439 7.84468C11.649 7.62366 12.7966 7.79235 13.7913 8.32204C14.7861 8.85174 15.5665 9.70972 16 10.75V10.75C16.4335 9.70972 17.2139 8.85174 18.2087 8.32204C19.2034 7.79235 20.351 7.62366 21.4561 7.84468C22.5612 8.0657 23.5555 8.66277 24.27 9.53431C24.9845 10.4059 25.375 11.498 25.375 12.625C25.375 19 16 24.25 16 24.25Z",
    stroke: "#1650FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorites);
export default __webpack_public_path__ + "static/media/favorites.bf4536dc95d98234855540f899d9afa6.svg";
export { ForwardRef as ReactComponent };